import * as Yup from "yup";

import { AddNoteFormValues } from "./AddNote";

export const MAX_NOTE_CHAR = 255;

const AddNoteSchema: Yup.SchemaOf<AddNoteFormValues> = Yup.object().shape({
  note: Yup.string()
    .required("Required")
    .max(MAX_NOTE_CHAR, `Maximum ${MAX_NOTE_CHAR} characters`)
    .default(""),
});

export default AddNoteSchema;
